'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n'], ['\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  font-size: 40px;\n'], ['\n  font-size: 40px;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Label = require('../Label/Label');

var _Label2 = _interopRequireDefault(_Label);

var _Input = require('../Input');

var _Input2 = _interopRequireDefault(_Input);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = _styledComponents2.default.div(_templateObject);

var LabelWrapper = _styledComponents2.default.div(_templateObject2);

function LabeledInput(props) {
  var labelText = props.labelText,
      restProps = _objectWithoutProperties(props, ['labelText']);

  return _react2.default.createElement(
    Wrapper,
    null,
    _react2.default.createElement(
      LabelWrapper,
      null,
      _react2.default.createElement(
        _Label2.default,
        { htmlFor: restProps.name },
        labelText
      )
    ),
    _react2.default.createElement(_Input2.default, restProps)
  );
}

LabeledInput.propTypes = {
  labelText: _propTypes2.default.string
};

LabeledInput.defaultProps = {
  labelText: "Label"
};

exports.default = LabeledInput;
LabeledInput.__docgenInfo = [{
  'description': '',
  'displayName': 'LabeledInput',
  'methods': [],
  'props': {
    'labelText': {
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': '',
      'defaultValue': {
        'value': '"Label"',
        'computed': false
      }
    }
  }
}];

if (typeof STORYBOOK_REACT_CLASSES !== 'undefined') {
  STORYBOOK_REACT_CLASSES['src/LabeledInput/index.js'] = {
    name: 'LabeledInput',
    docgenInfo: LabeledInput.__docgenInfo,
    path: 'src/LabeledInput/index.js'
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/oxyrion-ui/lib/LabeledInput/index.js
// module id = 317
// module chunks = 1